/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2019/11/22 10:15
 * @des
 */

const SessionCheck = require('@/base/sessioncheck')

import {
  getUrlParams,
  addUrlParams,
  getImageUrl
} from '@/base/util/urlutil'
import {
  addPageResizeListener,
  removePageResizeListener
} from '@/base/util/size'
import {
  addDocClickListener,
  removeDocClickListener
} from '@/base/util/document'
import {setTitle} from '@/base/util/compatible'
import {uuid} from '@/base/util/uuid'
import {
  postMessage,
  onmessage,
  close,
  closeAll
} from '@/base/util/broadcastchannel'
import {isLocalEn} from '../i18n'

export default {
  created () {
    if (this.$root == this || this.$route) {
      this._loadParams(this.$route)
    }
    if (this.onPageResize) {//监听窗口变化
      this.addPageResizeListener((width, height, isMobile) => {
        this.isMobile = isMobile
        this.pageWidth = width
        this.pageHeight = height
        this.onPageResize(width, height, isMobile)
      })
    }
    if (this.onDocClick) {//监听文档点击
      this.addDocClickListener((event) => {
        this.onDocClick(event)
      })
    }
  },
  destroyed () {
    if (this._resizeListener) {//移除监听
      this.removePageResizeListener()
    }
    closeAll(this.vuePageId)
  },
  data () {
    return {
      _resizeListener: null,
      isMobile: false,
      pageWidth: -1,
      pageHeight: -1,
    }
  },
  beforeRouteUpdate (to, from, next) {
    this._loadParams(to)
    next()
  },
  methods: {
    isLocalEn () {
      return isLocalEn()
    },
    jump (path, params) {
      let url = addUrlParams(path, params)
      window.location.href = url
    },
    jumpParams (path, params) {
      if (params) {
        params = {
          params: JSON.stringify(params)
        }
      }
      this.jump(path, params)
    },
    jumpWeexParams (path, params) {
      let jumpParams = {}
      if (params) {
        jumpParams.params = JSON.stringify(params)
      }
      jumpParams['_wx_tpl'] = addUrlParams(`dist${path}.js`, jumpParams)
      this.jump(path, jumpParams)
    },
    closePage () {
      window.location.href = 'about:blank'
      window.close()
      setTimeout(() => {//如果不生效回退两层
        window.history.go(-2)
      }, 100)
    },
    jumpHash (hash) {
      if (window.location.hash.substring(1) === hash) {
        window.location.reload()
      } else {
        window.location.hash = hash
      }
    },
    jumpParamsNewTab (path, params) {
      if (params) {
        params = {
          params: JSON.stringify(params)
        }
      }
      this.jumpNewTab(path, params)
    },
    jumpNewTab (path, params) {
      let url = addUrlParams(path, params)
      window.open(url, '_blank')
    },
    getUrlParams () {
      let params = getUrlParams(window.location.href)
      if (params.params) {
        return JSON.parse(params.params)
      }
      return params
    },
    checkSession (showTip = true) {
      SessionCheck.checkSession(showTip)
    },
    getCurrentUser (callback) {
      SessionCheck.getCurrentUser(callback)
    },
    /**
     * 当前是否是内容的创建者
     * @param creator 内容的创建者
     * @param callback (是否为内容创建者,当前登录的账户)
     */
    isCurrentCreator (creator, callback) {
      this.getCurrentUser((currentUser) => {
        if (!currentUser || !creator || creator !== currentUser) {
          callback(false, currentUser)
        } else {
          callback(true, currentUser)
        }
      })
    },
    _loadParams (route) {
      let params = {}
      if (route) {
        params = {...route.query, ...route.params}
      }
      if (Object.keys(params).length === 0) {
        params = this.getUrlParams()
      }
      if (this.loadParams) {
        this.loadParams(params)
      }
    },
    addPageResizeListener (_resizeListener) {
      if (!this._resizeListener) {
        this._resizeListener = _resizeListener
        addPageResizeListener(_resizeListener)
      } else {
        this.$log('一个组件限制只允许监听一次')
      }
    },
    removePageResizeListener () {
      removePageResizeListener(this._resizeListener)
    },
    addDocClickListener (_docClickListener) {
      if (!this._docClickListener) {
        this._docClickListener = _docClickListener
        addDocClickListener(_docClickListener)
      } else {
        this.$log('一个组件限制只允许监听一次')
      }
    },
    removeDocClickListener () {
      removeDocClickListener(this._docClickListener)
    },
    getImageUrl (name) {
      return getImageUrl(name)
    },
    getPlatformStyleName (className) {
      let classNames = {}
      classNames[className] = true
      classNames[`${className}-pc`] = !this.isMobile
      classNames[`${className}-mobile`] = this.isMobile
      return classNames
    },
    setTitle (title) {
      setTitle(title)
    },
    /**
     * 获取当前页面唯一id
     * @returns {*}
     */
    getPageId () {
      if (this.vuePageId === undefined || this.vuePageId === 0) {
        this.vuePageId = uuid()
      }
      return this.vuePageId
    },
    /**
     * 向频道发送消息
     * @param name 频道名
     * @param data 发送数据
     */
    postBroadcastChannelMessage (name, data) {
      postMessage(this.getPageId(), name, data)
    },
    /**
     * 监听频道消息
     * @param name 频道名
     * @param callback 结果返回
     */
    onBroadcastChannelMessage (name, callback) {
      onmessage(this.getPageId(), name, callback)
    },
    /**
     * 关闭当前页面频道
     * @param name 频道名
     */
    closeBroadcastChannel (name) {
      close(this.getPageId(), name)
    },
  },
}



// WEBPACK FOOTER //
// ./src/base/mixins/index.js